import * as React from 'react'
import { Box, Link, List, ListItem, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { catalogueAnalyzerRowClick } from '../../@signals'
import { useCatalogueAnalyzerGroupedVsSiteNavigation } from '../@hooks'


const common = {
    content: '""',
    position: 'absolute',
    borderColor: "divider",
    left: 0
}
const styles = (idx, numRow) => ({
    "&::before": {
        borderTop: "1px solid",
        ...common,
        top: "50%",
        width: 8,
        height: 0
    },

    "&::after": {
        borderLeft: "1px solid",
        ...common,
        top: 2,
        width: 0,
        height: (idx + 1) === numRow ? .48 : 1
    }
})

export default function groupedColumn(handleClickRow, groupedLabel) {
    return {
        name: 'grouped', label: groupedLabel,
        options: {
            headerAlign: 'left',
            customBodyRowRender: (value, { subRows, ...dataRow }, { rowIndex }) => {
                const { urlDetails } = useCatalogueAnalyzerGroupedVsSiteNavigation(dataRow)

                const isClicked = rowIndex === catalogueAnalyzerRowClick.value
                const icon = isClicked ? 'circle-minus' : 'circle-plus'

                return <Box sx={{ pt: 1, textWrap: 'nowrap' }}>
                    <IconSeeker icon={icon} iconWeight="regular" sx={{ cursor: 'pointer' }} onClick={() => handleClickRow(rowIndex)} />
                    <Typography variant="subtitle2" sx={{ ml: 1, display: 'inline' }}>
                        <Link href={urlDetails} target="_blank" sx={{ cursor: 'pointer', color: 'inherit' }}>
                            {value}
                        </Link>
                    </Typography>
                    { !!isClicked  && <List sx={{ ml: 1, pt: 2 }}>
                        {subRows.map(({ secondaryGrouped }, idx) => <ListItem key={idx} sx={styles(idx, subRows.length)}>
                            {secondaryGrouped}
                        </ListItem>)}
                    </List> }
                </Box>
            }
        }
    }
}